export const NOTIFICATION_CLOSING_DURATION = 5000;
